'use client';
import { cn } from '@dolcevia/lib/utils';
import {
  ToggleGroup,
  ToggleGroupItem,
} from '@dolcevia/ui/components/ui/toggle-group';

type FilterProps = {
  setCategory?: (category: string) => void;
  items: Array<{
    value: string;
    label: string;
  }>;
  className?: string;
  defaultValue?: string;
};
export const Filter = ({
  setCategory,
  items,
  className,
  defaultValue,
}: FilterProps) => {
  return (
    <ToggleGroup
      onValueChange={setCategory}
      defaultValue={defaultValue}
      type="single"
      className={cn('gap-4 text-slate-500', className)}
    >
      {items.map((item) => (
        <ToggleGroupItem
          key={item.value}
          value={item.value}
          variant="outline"
          className="data-[state=on]:text-deep-blue-100"
        >
          {item.label}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
};
